import { Icons } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'

type Props = {
  contractId: string
  onSuccess: refetchFunc
}

export const RemoveContract = ({ contractId, onSuccess }: Props) => {
  const { t } = useTranslation('deal')
  const [removeModal, setRemoveModal] = useState(false)
  const [progress, removeHandler] = useAProgress(
    (contractId) => apiClient.delete(endpoints.dealsContracts(contractId)),
    {
      eventName: 'deleteDealContractRequest',
      analyticsPayload: { id: contractId },
      onSuccess,
    },
  )

  return (
    <>
      <AButton
        onClick={() => setRemoveModal(true)}
        id="removeDealContractRequest"
        Icon={Icons.IconCancelled}
        color="secondary"
        background="none"
      />
      {removeModal && (
        <ResponsiveModal
          title={t('requestContractBlock.remove_modal_title')}
          onConfirm={() => removeHandler(contractId)}
          confirmButtonText={t('common:confirm')}
          onClose={() => setRemoveModal(false)}
          id="removeDealContractRequest"
          progress={progress}
          size="small"
        >
          <SharedModalContent>{t('requestContractBlock.remove_modal_text')}</SharedModalContent>
        </ResponsiveModal>
      )}
    </>
  )
}
